/* eslint-disable */
/* tslint:disable */

/** getAll
 * method: get
 * summary: fetch the authenticated worker's list of jobs with sub categories
 */

import type {
  MyJobsWithSpecialtiesResponseDto,
  ApiResponseDto,
} from './../api-types'

export const path = `/bff-worker/profile/my-jobs-with-specialties`
export const fullPath = `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/profile/my-jobs-with-specialties`

export type GetAllSuccess = MyJobsWithSpecialtiesResponseDto
export type GetAllError = ApiResponseDto
